export const ACTUALIZAR_LIST_SISTEMA = "ACTUALIZAR_LIST_SISTEMA";

